import { getArnPayload } from "../../components/Kpi/FleetData_";
import { axInst, axInstBasic } from "../../components/Service/Service";
import axios from "axios";

export const fetchPvinToken = async () => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}pvin-token`
    );
    return res?.data;
  } catch (error) {
    console.error("Error Message", error);
  }
};

export const fetchPvinData = async (pvinToken, selectedArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}pvin-data`,
      { pvinToken, selectedArn }
    );
    return res?.data;
  } catch (error) {
    console.error("Error Message", error);
  }
};

export const getCustomerData = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getCustData`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

export const fetchlastPurchahedPVIN = async (arn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}lastPurchahed`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCouponPopupTotalDataPVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}couponPopupTotalData`,
      { parArn, childArn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCouponPopupUsedlDataPVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}couponPopupUsed`,
      { parArn, childArn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCouponPopupBalanceDataPVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}couponPopupBalance`,
      { parArn, childArn }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCouponPopupExpiredDataPVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}couponPopupExpired`,
      { parArn, childArn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchsixqtytablePVIN = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sixMonthPurchaseQuantityData`,
      payload
    );
    return res.data?.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchComplaintDetailsBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintDetailsBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchComplaintDetailspopup = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}custCompPopup`,
      payload
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchComplaintDetailsNonBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ComplaintDetailsNonBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Service Summary
// 1.
export const fetchserviceTATBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}serviceTATBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 2.
export const fetchTotalJobcardBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}TotalJobcardBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 3.
export const fetchAvgTATBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}avgTATBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 4.
export const fetchActiveAMCBs6VIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}activeAMCBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 5.
export const fetchOpenJobcardBs6VIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}OpenJobcardBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 6.

export const fetchAvgInvoiceAmountBs6VIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}avgInvoiceAmountBs6`,
      { parArn, childArn }
    );
    return res.data?.formatted;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// NON-BS6
// 1.
export const fetchServiceTATNonBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ServiceTATNonBs6`,
      { parArn, childArn }
    );
    // console.log("Response from KPI", res);
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 2.
export const fetchtotalJobcardNonBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}totalJobcardNonBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 3.
export const fetchAvgTATNonBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}avgTATNonBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 4.
export const fetchactiveAMCnonBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}activeAMCnonBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 5.
export const fetchOpenJobcardnonBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}openJobcardnonBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 6.
export const fetchAvgInvoiceAmountNonBs6PVIN = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}avgInvoiceAmountNonBs6`,
      { parArn, childArn }
    );
    return res.data?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
